module.exports = __webpack_public_path__ + "media/images/flags/64/Laos-9d5536e2b301bc8324de9367cdc9cb7d.png";